<svg xmlns="http://www.w3.org/2000/svg" width="120" height="76" viewBox="0 0 120 76">
    <defs>
        <linearGradient id="g44lrnbn0a" y1="50%" y2="50%" x1="41.129%" x2="66.71%">
            <stop offset="0%" stop-color="#D90338"/>
            <stop offset="100%" stop-color="#0069C4"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g fill="url(#g44lrnbn0a)" transform="translate(-8 -5) translate(8 5)">
                    <path d="M0 0H120V76H0z"/>
                </g>
                <text fill="#FFF" font-family="GrundfosTheSansV2OT-7B, Grundfos TheSans V2 OT" font-size="10" font-weight="400" letter-spacing="-.068" transform="translate(-8 -5) translate(8 5)">
                    <tspan x="48" y="42">LOAD</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>
